import * as React from "react";
import {cs} from "../../../../../../../react/chain-services";
import {UseState} from "../../../../../../../react/use-state";
import {cx} from "emotion";
import "./step-1-search.scss";
import {ConfirmCancel} from "../../common/confirm-cancel";
import {Header} from "../../common/header/header";
import {SearchForm} from "./search-form/search-form";
import {SearchResult} from "./search-result/search-result";
import {randomId} from "../../../../../../../utils/random";

export const Step1Search = ({onCancel, cancelLabel, onClose, entityId, onNext, streets, next}) => cs(
    ["confirmCancel", (_, next) => ConfirmCancel({next})],
    ["searchResult", ({}, next) => SearchResult({
        streets,
        next,
    })],
    ["persistInvalid", (_, next) => UseState({
        initValue: false,
        next
    })],
    ({confirmCancel, searchResult, persistInvalid}) => next({
        onPassiveClose: streets.value?.length ? confirmCancel : null,
        content: cs(

            ({}) => (
                <div className="step-1-search-5fv">
                    {Header({
                        icon: require("../../../../mailing-icons/listtype-street.png"),
                        title: "Build Street List",
                        subTitle: "Build a list targeting prospects on a specific street.",
                    })}

                    {SearchForm({
                        onAdd: (street) => streets.change((_) => [..._??[], {...street, key: randomId()}]),
                        isExisted: (street) => streets.value?.find((s1) => s1.street.address === street.address && s1.street.zip_code === street.zip_code),
                        entityId
                    })}

                    {streets.value?.length ? <>
                        {searchResult.render()}

                        {Footer({confirmCancel, cancelLabel, searchResult, persistInvalid, onClose, onNext})}
                    </> : <>

                        <div className="footer">
                            <div className="text" xd-qa-type="label" xd-qa-name={"Build Street List " + cancelLabel}>
                                <a onClick={onCancel} xd-qa-type="link" xd-qa-name={"Build Street List " + cancelLabel}>{cancelLabel}</a>
                            </div>
                        </div>

                    </>}

                </div>
            ),
        ),
    }),
);

const Footer = ({confirmCancel, cancelLabel, searchResult, persistInvalid, onClose, onNext}) => (
    <div className="footer">
        <button {...{
            className: "cancel",
            onClick: async () => {
                if (await confirmCancel()) {
                    onClose();
                }
            },
            "xd-qa-type": "button",
            "xd-qa-name": "Build Street List" + cancelLabel,
        }}>
            {cancelLabel}
        </button>

        <button {...{
            className: cx("next", {disabled: !searchResult.valid}),
            onMouseDown: () => {
                if (!searchResult.valid) {
                    persistInvalid.onChange(true);
                } else {
                    persistInvalid.onChange(false);
                }
            },
            onClick: () => {
                if (persistInvalid.value) {
                    searchResult.highlightErrors();
                } else {
                    onNext();
                }
            },
            "xd-qa-type": "button",
            "xd-qa-name": "Build Street List Next",
        }}>
            Next
        </button>
    </div>
);

